module.exports = __webpack_public_path__ + "img/blue_169.e3c1682c.png";